import React, { useCallback, useContext, useEffect, useState } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { FirstTimeFlag } from '../../../redux/firstTimeFlags';
import { useFirstTimeFlag } from '../../../redux/firstTimeFlags/hooks';
/** A context provider that moves the deviation page through the two stages
 *  displayed for the IsMsSubscriptionNotPurchased flag.
 *
 *  The first stage, 'overlay' displays a congrats overlay over the devpage
 *  artstage and, when that's clicked, goes to the next stage 'tooltips'
 *  where the tooltips above the download button and the SubscribersOnly
 *  badge open until the window is clicked or scrolled.
 */ export const SubscriptionPurchaseFTUEContext = /*#__PURE__*/ React.createContext(null);
SubscriptionPurchaseFTUEContext.displayName = 'SubscriptionPurchaseFTUEContext';
export const SubscriptionPurchaseFTUEContextProvider = ({ deviation, children })=>{
    const { isLoggedIn } = useContext(SessionContext);
    const { isInTier, isOwner, isUserSubscribed, isSubscribedButBlocked } = useSubscriptionTier(deviation);
    const { hasFlag: IsMsSubscriptionNotPurchased, dropFlag } = useFirstTimeFlag(FirstTimeFlag.IsMsSubscriptionNotPurchased);
    const isFTUEShown = isLoggedIn && isInTier && isUserSubscribed && !isOwner && !isSubscribedButBlocked && IsMsSubscriptionNotPurchased;
    const initialPhase = isFTUEShown ? 'overlay' : null;
    const [ftuePhase, setFtuePhase] = useState(initialPhase);
    const moveToNextFtuePhase = useCallback(()=>{
        if (ftuePhase === 'overlay') {
            dropFlag();
            setFtuePhase('tooltips');
        } else {
            setFtuePhase(null);
        }
    }, [
        ftuePhase,
        dropFlag
    ]);
    // when we're in the overlay phase, listen for any click or scrolling
    // and then move to the next phase
    useEffect(()=>{
        if (ftuePhase !== 'overlay') {
            return;
        }
        // any click and doesn't matter if it propagates
        window.addEventListener('click', moveToNextFtuePhase, {
            once: true
        });
        window.addEventListener('scroll', moveToNextFtuePhase, {
            once: true
        });
        return ()=>{
            window.removeEventListener('click', moveToNextFtuePhase);
            window.removeEventListener('scroll', moveToNextFtuePhase);
        };
    }, [
        ftuePhase,
        moveToNextFtuePhase
    ]);
    // in the tooltips phase, listen for any click and then end the ftue
    useEffect(()=>{
        if (ftuePhase !== 'tooltips') {
            return;
        }
        window.addEventListener('click', moveToNextFtuePhase, {
            once: true
        });
        return ()=>{
            window.removeEventListener('click', moveToNextFtuePhase);
        };
    }, [
        ftuePhase,
        moveToNextFtuePhase
    ]);
    return /*#__PURE__*/ React.createElement(SubscriptionPurchaseFTUEContext.Provider, {
        value: ftuePhase
    }, children);
};
SubscriptionPurchaseFTUEContextProvider.displayName = 'SubscriptionPurchaseFTUEContextProvider';

//# sourceMappingURL=SubscriptionPurchaseFTUEContext.js.map